/** Registration steps */
var stepsCount = $('#aad-quiz .quiz-section').length - 1,
  steps = '';
  
for (var i = -1; i < stepsCount; i++) {
  steps += '<div class="step" data-number="' + (i + 1) + '"><div class="step__line"></div><div class="step__circle"></div></div>';
}

/** Append the steps */
$('#aad-quiz').prepend('<div id="quiz-steps" class="aad-steps container mt-5 pt-5">' + steps + '</div>');

/** Create the first active panel */
// $('.rcp_form fieldset').first().addClass('active'); 

/** Next section button */
$(document).on('click', '#aad-quiz .quiz-advance', function () {
  var $self = $(this),
    $next = $self.parents('fieldset').next('fieldset'),
    $inputs = $self.parents('fieldset').find('.required');
  
  $inputs.each(function () {
    $(this).valid();
  });

  var invalidFieldsCount = $self.parents('fieldset').find('.field-wrap.has-error').length;

  if (invalidFieldsCount <= 0) {

    var activeSteps = $('#aad-quiz .steps .step.active').length;
    if (activeSteps === 0) {
      $('#aad-quiz .steps .step').first().addClass('active');
    } else {
      var current = $('#aad-quiz .steps .step.active').attr('data-number');

      $('#aad-quiz .steps .step.active').removeClass('active').addClass('completed');
      $('#aad-quiz .steps .step[data-number="' + (Number(current) + 1) + '"]').addClass('active');
    }
  }
});

/** Previous section button */
$(document).on('click', '#aad-quiz fieldset .prev-section', function () {
  // var $self = $(this),
  //   $prev = $self.parents('fieldset').prev('fieldset');

  // $('#aad-quiz fieldset').removeClass('active');
  // $prev.addClass('active');

  // $('html, body').animate(
  //   {
  //     scrollTop: 0
  //   },
  //   300
  // );

  var current = $('#aad-quiz .steps .step.active').attr('data-number');

  $('#aad-quiz .steps .step').removeClass('active');
  $('#aad-quiz .steps .step[data-number="' + (Number(current) - 1) + '"]').addClass('active');
});